import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { promotions, mobilePromotion } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center m="15px auto" w="100%">
          <CFImage src={mobilePromotion} w="100%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" m="0 auto" w="100%">
          <CFImage src={promotions} w="100%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
